import { render, staticRenderFns } from "./BpModal.vue?vue&type=template&id=dc997f4c&"
import script from "./BpModal.vue?vue&type=script&lang=js&"
export * from "./BpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc997f4c')) {
      api.createRecord('dc997f4c', component.options)
    } else {
      api.reload('dc997f4c', component.options)
    }
    module.hot.accept("./BpModal.vue?vue&type=template&id=dc997f4c&", function () {
      api.rerender('dc997f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/styles/organisms/modal/BpModal.vue"
export default component.exports